import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTRadioButton {
    innerValue = true;

    $onChanges() {
        this.innerValue = this.value;
    }

    valueChange() {
        const value = this.innerValue;

        this.onChange({ value });
    }
}

export const TFTRadioButtonConfiguration = {
    template,
    bindings: {
        radioButtonId: '@',
        groupName: '@',
        testId: '@',
        disabled: '<',
        value: '<',
        checkedValue: '<',
        labelTranslateKey: '@',
        onChange: '&',
    },
    controller: TFTRadioButton,
    controllerAs: 'radioButtonCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftRadioButton', TFTRadioButtonConfiguration);
